import { MethodTypeRepository } from '@telespot/domain';

export interface ICountMethodTypesQuery {
  /**
   * Counts method types matching an optional search term.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(searchTerm?: string): Promise<number>;
}

export class CountMethodTypesQuery implements ICountMethodTypesQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(searchTerm?: string): Promise<number> {
    return this.methodTypeRepository.count(searchTerm);
  }
}
